import { Link } from 'react-router-dom';
import { FACILITATORS, ASSETS, SHARED_VISION } from '../lib/content';

export default function Facilitators() {
  return (
    <div data-testid="page-facilitators">
      <section className="relative h-[40vh] min-h-[320px]">
        <img src={ASSETS.goldField} alt="A gentle golden meadow at warm light" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-bg/30 via-brand-bg/30 to-brand-bg" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-7xl mx-auto px-6 md:px-12 pb-14 w-full text-center">
            <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-brand-brown-muted mb-4 bg-brand-bone/80 inline-block px-4 py-1.5 rounded-full">The Facilitators</p>
            <h1 className="font-serif text-5xl md:text-6xl text-brand-brown leading-[1.05] max-w-3xl mx-auto">
              Those who walk <em className="italic text-brand-brown-light">alongside</em> you.
            </h1>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <p className="font-sans text-base md:text-lg text-brand-brown-light/90 leading-relaxed">
            Nurture the Self is held by experienced practitioners who bring both professional depth and personal understanding to the work — companions on the path rather than experts above it.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12 space-y-24">
          {FACILITATORS.map((f, i) => (
            <article
              key={f.name}
              data-testid={`facilitator-${i}`}
              className={`grid md:grid-cols-5 gap-10 md:gap-16 items-start ${i % 2 === 1 ? 'md:[&>div:first-child]:order-2' : ''}`}
            >
              <div className="md:col-span-2">
                <div className="relative">
                  <div className={`absolute -inset-3 rounded-3xl ${i % 2 === 0 ? 'bg-brand-peach/40 -rotate-1' : 'bg-brand-sage rotate-1'}`} aria-hidden />
                  <img
                    src={f.photo}
                    alt={`Portrait of ${f.name}`}
                    className="relative rounded-3xl object-cover w-full aspect-[4/5]"
                  />
                </div>
              </div>
              <div className="md:col-span-3">
                <h2 className="font-serif text-4xl md:text-5xl text-brand-brown leading-tight">{f.name}</h2>
                <p className="mt-3 font-sans text-xs uppercase tracking-[0.18em] text-brand-gold leading-relaxed max-w-prose">{f.role}</p>
                <div className="mt-7 space-y-5 font-sans text-base text-brand-brown-light/90 leading-relaxed">
                  {f.bio.map((para, idx) => <p key={idx}>{para}</p>)}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* SHARED VISION */}
      <section className="py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-brand-brown-muted mb-4">Together</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-brown leading-tight">{SHARED_VISION.title}</h2>
          </div>
          <div className="space-y-6 font-sans text-base md:text-lg text-brand-brown-light/95 leading-relaxed">
            {SHARED_VISION.paragraphs.map((p, i) => (
              <p key={i} data-testid={`shared-vision-p-${i}`} dangerouslySetInnerHTML={{
                __html: p.replace(/\*([^*]+)\*/g, '<em class="italic text-brand-brown">$1</em>'),
              }} />
            ))}
          </div>
          <div className="mt-12 text-center">
            <div className="divider-leaf mb-6" />
            <p className="font-serif italic text-2xl md:text-3xl text-brand-gold tracking-wide">
              {SHARED_VISION.closing}
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-bg-soft">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h3 className="font-serif text-3xl md:text-4xl text-brand-brown">Curious to meet us?</h3>
          <p className="mt-5 font-sans text-base text-brand-brown-light/90 leading-relaxed">
            Every journey begins with a complimentary intake conversation — a quiet first meeting to sense whether this path feels right for you.
          </p>
          <Link
            to="/booking"
            data-testid="facilitators-cta"
            className="mt-9 inline-flex font-sans text-sm tracking-wide bg-brand-brown text-brand-bg rounded-full px-8 py-3.5 hover:bg-brand-brown-light transition-colors duration-500"
          >
            Book an intake conversation
          </Link>
        </div>
      </section>
    </div>
  );
}
